import { React } from "react";

import Footer from "../Footer";

// IMAGES FOR PAGE
import perfSect2ImgSm from "../../assets/performances/SummerConcerto2026/SummerConcertoPoster-300.png";
import perfSect2ImgMd from "../../assets/performances/SummerConcerto2026/SummerConcertoPoster-768.png";
import perfSect2ImgLg from "../../assets/performances/SummerConcerto2026/SummerConcertoPoster-1280.png";
import perfSect2ImgXL from "../../assets/performances/SummerConcerto2026/SummerConcertoPoster-2000.png";
import programLink from "../../assets/performances/SummerConcerto2026/SummerConcerto2026Program.pdf";

import PerformanceTemplate from "./templates/PerformanceTemplate";

import "./SummerConcerto2026.css";

function SummerConcerto2026() {
  const status = "PAST";
  const showName = "Summer Concerto";
  const showDate = "July 25, 2026";
  const headerDescription = `Nylia Ballet Academy's Summer Concerto, featuring our Nylia Ballet Company & Youth Company and summer intensive students!`;
  const program = programLink;
  const handbook = "";

  const auditionDate = "FEBRUARY 1, 2026";
  const perfSect2ButtonLink = program;
  const perfSect2Images = {
    sm: perfSect2ImgSm,
    md: perfSect2ImgMd,
    lg: perfSect2ImgLg,
    xl: perfSect2ImgXL,
  };

  // const importantLinks = [
  //   { buttonLabel: "Cast list", buttonLink: castList },

  //   {
  //     buttonLabel: "rehearsal schedule",
  //     buttonLink: rehearsalSchedule,
  //   },
  //   {
  //     buttonLabel: "Rehearsal Attire",
  //     buttonLink: rehearsalReqs,
  //   },
  //   { buttonLabel: "Costume Requirements", buttonLink: costumeReqs },
  //   // { buttonLabel: "volunteers", buttonLink: "" }, //todo
  // ];

  return (
    <div id="summerConcerto2026Div">
      <PerformanceTemplate
        status={status}
        showName={showName}
        showDate={showDate}
        headerDescription={headerDescription}
        auditionDate={auditionDate}
        performanceWeek={false}
        perfSect2ButtonLink={perfSect2ButtonLink}
        perfSect2Images={perfSect2Images}
        // importantLinks={importantLinks}
        // eventCalendar={eventCalendar}
        handbookLink={handbook}
        perfSect2PerformanceWeekButtonLink={program}
      />
      <Footer />
    </div>
  );
}

export default SummerConcerto2026;
